module.exports = __webpack_public_path__ + "img/up-cultura-up-onlline.58225614.png";